import { Box, Button, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { MuiStyledInput } from '../muiControls';

import useExportData from './useExportData';

const BlueText = ({ ...restOfProps }) => (
    <Box
        component="span"
        sx={(theme) => {
            return { color: theme.palette.primary.main, fontWeight: 600 };
        }}
        {...restOfProps}
    />
);

const ExportData = ({ selected, closeCallback, ...restOfProps }) => {
    const { fileName, sendReport, handleFileName, isDoingAjax } = useExportData();

    return (
        <Dialog {...restOfProps}>
            <DialogTitle>Export selected records</DialogTitle>

            <DialogContent>
                <Box>
                    <Typography>
                        Enter the name of the file and then click <BlueText>Export Records</BlueText> to create the report. Please do{' '}
                        <BlueText>not</BlueText> include the extension (i.e. .pdf) in the file name field.
                    </Typography>

                    <MuiStyledInput
                        label="File Name:"
                        id="filename"
                        value={fileName}
                        onChange={handleFileName}
                        disabled={isDoingAjax}
                    />
                </Box>
                <Box>
                    <Button
                        onClick={closeCallback}
                        disabled={isDoingAjax}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        onClick={() => sendReport(selected, closeCallback)}
                        disabled={isDoingAjax}
                    >
                        Export Records
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default ExportData;
